$("._home-slider").each(function () {
    const home = $(this);

    home.find("._btn-prev-slide").on("click", function () {
        home.find(".slider").slick("slickPrev");
    });

    home.find("._btn-next-slide").on("click", function () {
        home.find(".slider").slick("slickNext");
    });

    home.find(".slider")
        .slick({
            slidesToShow: 1,
            variableWidth: true,
            infinite: true,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
        })
        .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
            console.log(event, slick, currentSlide, nextSlide);
            home.find("._current-page").html(
                (nextSlide + 1).toString().padStart(2, "0") +
                    " / " +
                    slick.slideCount.toString().padStart(2, "0")
            );
        })
        .slick("slickGoTo", 0);
});
